// ─── Promotion & Pricing Configuration ────────────────────────────────────
// Edit this file to toggle promotions, change banner copy, or update prices.
// No component code needs to change.

// --- Top Banner -----------------------------------------------------------
// Set to `false` to hide the banner entirely.
export const SHOW_BANNER = true

// The text displayed inside the top banner when SHOW_BANNER is true.
// Each field maps to a visually distinct segment in the banner.
export const BANNER_TEXT = {
  label: 'Special Offer:',                                    // bold prefix
  message: 'Get a 3-Day FREE Trial + your first month for just', // body copy
  discountPrice: '$4.99',                                     // bold highlight price
  originalPrice: '$29.99',                                    // struck-through original
  tag: 'limited-time deal',                                   // italic suffix
}

// --- Discount Flag ---------------------------------------------------------
// Master switch for the discount shown on plan cards.
// When false, every plan renders only its base price (offerPrice / offerLabel are ignored).
export const DISCOUNT_ENABLED = true

// --- Plan Prices -----------------------------------------------------------
export const PLAN_PRICES = {
  free: {
    price: '$0',
  },
  pro: {
    price: '$29.99',            // base / original price
    priceUnit: '/ user',
    offerPrice: '$4.99',        // discounted price (used only when DISCOUNT_ENABLED)
    offerLabel: 'First month only',
  },
  enterprise: {
    price: 'Custom',
  },
} as const
